import { Dispatch, SetStateAction } from 'react';
import { handleErrorToast } from 'src/components/molecules';
import { CategoryType } from 'src/graphql';
import { HumanReadableLanguages } from 'src/types';
import { validateCSVSecurity } from 'src/utils/csvsecurity';
import { isDuplicateName } from '../../UpdateCategoryModal/helpers';

interface Parameters {
  id: number;
  name: string;
  category: CategoryType;
  setName: Dispatch<string>;
  currentLocale: keyof typeof HumanReadableLanguages;
  categories: CategoryType[];
  updateCategoryLocale: (
    id: number,
    locale: string,
    name: string,
    description: string,
  ) => void;
  currentCategory: CategoryType | null;
  isCurrentCategory: boolean;
  setCurrentCategory: Dispatch<SetStateAction<CategoryType | null>>;
}

export const handleOnSaveTitle = ({
  id,
  name,
  category,
  setName,
  currentLocale,
  categories,
  updateCategoryLocale,
  currentCategory,
  isCurrentCategory,
  setCurrentCategory,
}: Parameters) => {
  const categoryNames = categories.map(
    (category) => category.locales?.[currentLocale]?.name,
  );
  const duplicateName = isDuplicateName(name, categoryNames);
  const isCsvSafe = validateCSVSecurity(name);

  if (name === category.locales?.[currentLocale]?.name) {
    return;
  } else if (name.trim() === '') {
    setName(category.locales?.[currentLocale]?.name);
    handleErrorToast({
      toastMessage:
        'Please provide a category name. Your changes have not been saved.',
    });
  } else if (duplicateName) {
    setName(category.locales?.[currentLocale]?.name);
    handleErrorToast({
      toastMessage:
        'Category name already exists. Please enter a unique name or modify the existing category. Your changes have not been saved.',
    });
  } else if (!isCsvSafe) {
    setName(category.locales?.[currentLocale]?.name);
    handleErrorToast({
      toastMessage:
        'Category name cannot start with special characters. Your changes have not been saved.',
    });
  } else {
    updateCategoryLocale(
      id,
      currentLocale,
      name,
      category.locales[currentLocale]?.description ?? '',
    );
    if (isCurrentCategory && currentCategory) {
      setCurrentCategory({
        ...currentCategory,
        locales: {
          ...currentCategory.locales,
          [currentLocale]: {
            name: name,
            description:
              currentCategory.locales[currentLocale]?.description ?? '',
          },
        },
      });
    }
  }
};
